import React from 'react';
import { injectIntl } from 'react-intl';
import { SearchContextProvider } from './use-search';
import { SearchBar } from './SearchBar';
import { useWindowSize } from '../../utils/hooks/use-window-size';
import { TABLET_LANDSCAPE_MAX } from '../utils/design/breakpoints';
import { MobileSearchTray } from './MobileSearchTray';
import { handleSearch } from '../utils/search/handle-search';

export const SearchWidget = injectIntl((props) => {
  const windowDims = useWindowSize();

  return (
    <SearchContextProvider
      {...props}
      defaultActivity={props.searchActivity}
      defaultLocation={props.searchLocation}
      currentLocale={props.locale}
      onSearch={handleSearch}
      origin={props.origin}
    >
      {
        windowDims.width > TABLET_LANDSCAPE_MAX ?
          <SearchBar /> :
          <MobileSearchTray />
      }
    </SearchContextProvider>
  );
});
